var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('img',{staticStyle:{"width":"149px","height":"63px"},attrs:{"alt":"Logo Provincie Vlaams-Brabant","src":"/img/logo.png"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }